import React from 'react';
const AdminEvents = () => <div className="min-h-screen p-8">Admin Events Management</div>;
export default AdminEvents; 